import { initClient } from './client'

export const init = ({ config }) => {
	const storeCode = __NEXT_DATA__.props.pageProps.__bh__currentStoreCode
	const { groupId } = config.availableStores.find(({ code }) => code === storeCode) || {}

	// returns a client instance
	return initClient({
		baseURL: process.env.NEXT_PUBLIC_BH_PROXY_API_PATH_TO_EXPOSE,
		storeCode,
		groupId: groupId,
	})
}

export default init
